import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Stepper from "../../components/steper/Stepper";
import { useDispatch, useSelector } from "react-redux";
import "./companypage.css";
import { fetchPincodeDeatails } from "../../redux/slices/pincodeSlice";
import { updateMember } from "../../redux/slices/memberSlice";
import { MapPinPlus } from "lucide-react";
import { toast } from "react-toastify";

const CompanyFromStep = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dropdownRef = useRef();
  const [user, setUser] = useState(null);
  const [memberId, setMemberId] = useState(null);
  const savedStep1 = JSON.parse(localStorage.getItem("companyStep1")) || {};
  const { data: pincodeResults } = useSelector((state) => state.pincode);
  const [errors, setErrors] = useState({});
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    alt_phone: "",
    email: "",
    designation: "",
    member_address: {
      member_firm_address: "",
      member_state: "",
      member_city: "",
      member_pin: "",
    },
    ...savedStep1,
  });

  useEffect(() => {
  const storedUser = localStorage.getItem("user");
  if (storedUser) {
    try {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);
      setMemberId(parsedUser.member_id);

      setFormData((prevState) => ({
        ...prevState,
        name: parsedUser.member_contact_name || "",
        phone: parsedUser.member_mobile || "",
        alt_phone: parsedUser.member_alt_mobile || "",
        email: parsedUser.member_email || "",
        designation: parsedUser.member_designation || "",
        member_address: {
          member_firm_address: parsedUser.member_firm_address || "",
          member_state: parsedUser.member_state || "",
          member_city: parsedUser.member_city || "",
          member_pin: parsedUser.member_pin || "",
        },
      }));
    } catch (error) {
      console.error("Error parsing user data from localStorage:", error);
    }
  }
}, []);


  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChange = (e) => {
    let { name, value } = e.target;
    // Restrict member_pin to digits only (no alphabets/special characters)
    if (name === "member_pin") {
      value = value.replace(/\D/g, ""); // Remove non-digit characters
      if (value.length > 6) value = value.slice(0, 6); // Limit to 6 digits
    }
    if (name.startsWith("member_")) {
      setFormData((prevState) => ({
        ...prevState,
        member_address: {
          ...prevState.member_address,
          [name]: value,
        },
      }));

      if (name === "member_pin" && /^\d{6}$/.test(value)) {
        dispatch(fetchPincodeDeatails(value));
        setDropdownVisible(true);
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.phone) newErrors.phone = "Mobile number is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.designation)
      newErrors.designation = "Designation is required";

    const address = formData.member_address;
    if (!address.member_firm_address)
      newErrors.member_firm_address = "Firm address is required";
    if (!address.member_state) newErrors.member_state = "State is required";
    if (!address.member_city) newErrors.member_city = "City is required";

    // Validate PIN: must be 6-digit
    if (!address.member_pin) {
      newErrors.member_pin = "Pincode is required";
    } else if (!/^\d{6}$/.test(address.member_pin)) {
      newErrors.member_pin = "Invalid pincode (must be 6 digits)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const action = e.nativeEvent.submitter.value;
    if (!validateForm()) return;

    const payload = {
      member_id: memberId,
      member_firm_name: savedStep1.firm_name,
      member_contact_name: formData.name,
      member_type: 2,
      member_email: formData.email,
      member_designation: formData.designation,
      member_mobile: formData.phone,
      member_alt_mobile: formData.alt_phone,
      member_service_emails: formData.email,
      member_firm_address:
        formData.member_address.member_firm_address +
        ", " +
        formData.member_address.member_city +
        ", " +
        formData.member_address.member_state +
        ", " +
        formData.member_address.member_pin,
      member_state: savedStep1.member_state,
      member_city: savedStep1.member_city,
      member_pin: savedStep1.member_pin,
      member_business_type: savedStep1.member_business_type,
    };

    try {
      const resultAction = await dispatch(updateMember(payload));
      if (updateMember.fulfilled.match(resultAction)) {
        if (action === "proceed") {
          toast.success("Successfully saved. Proceeding to KYC.");
          navigate("/kydetailsform", { state: { payload } });
        } else {
          toast.success("Saved as Draft.");
        }
      } else {
        console.error("Update failed:", resultAction.payload);
      }
    } catch (err) {
      console.error("Error during update:", err);
    }
  };

  const handleDropdownSelect = (office) => {
    setFormData((prevState) => ({
      ...prevState,
      member_address: {
        ...prevState.member_address,
        member_firm_address: office.Name,
        member_city: office.District,
        member_state: office.State,
        member_pin: office.Pincode,
      },
    }));
    setDropdownVisible(false);
  };

  return (
    <>
      <div className="stepper_root">
        <Stepper currentStep={1} />
      </div>

      <div className="form-container">
        <form className="custom-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={errors.name ? "error-border" : ""}
            />
            {errors.name && <span className="error-text">{errors.name}</span>}
          </div>

          <div className="form-group">
            <label>Mobile Number *</label>
            <input
              type="number"
              name="phone"
              value={formData.phone}
              readOnly
              className="readonly-field"
            />
            {errors.phone && <span className="error-text">{errors.phone}</span>}
          </div>

          <div className="form-group">
            <label>Alternate Mobile Number (Optional)</label>
            <input
              type="number"
              name="alt_phone"
              value={formData.alt_phone}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handleChange(e);
                }
              }}
            />
          </div>

          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? "error-border" : ""}
            />
            {errors.email && <span className="error-text">{errors.email}</span>}
          </div>

          <div className="form-group">
            <label>Member Designation*</label>
            <input
              type="text"
              name="designation"
              value={formData.designation}
              onChange={handleChange}
              className={errors.designation ? "error-border" : ""}
            />
            {errors.designation && (
              <span className="error-text">{errors.designation}</span>
            )}
          </div>

          <div
            className="form-group"
            ref={dropdownRef}
            style={{ position: "relative" }}
          >
            <label>Member Pincode *</label>
            <input
              type="text"
              name="member_pin"
              value={formData.member_address.member_pin}
              onChange={handleChange}
              autoComplete="off"
              className={errors.member_pin ? "error-border" : ""}
              maxLength={6}
            />
            {errors.member_pin && (
              <span className="error-text">{errors.member_pin}</span>
            )}

            {dropdownVisible && pincodeResults?.length > 0 && (
              <div className="dropdown">
                {pincodeResults.map((office, index) => (
                  <div
                    key={index}
                    className="dropdown-item"
                    onClick={() => handleDropdownSelect(office)}
                  >
                    <MapPinPlus color="#007bff" /> &nbsp;
                    {office.Name}, {office.Block}, {office.District},{" "}
                    {office.Country}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="form-group">
            <label>Member Firm Address *</label>
            <input
              type="text"
              name="member_firm_address"
              value={formData.member_address.member_firm_address}
              onChange={handleChange}
              className={errors.member_firm_address ? "error-border" : ""}
            />
            {errors.member_firm_address && (
              <span className="error-text">{errors.member_firm_address}</span>
            )}
          </div>

          <div className="form-group">
            <label>Member State *</label>
            <input
              type="text"
              name="member_state"
              value={formData.member_address.member_state}
              onChange={handleChange}
              className={errors.member_state ? "error-border" : ""}
            />
            {errors.member_state && (
              <span className="error-text">{errors.member_state}</span>
            )}
          </div>

          <div className="form-group">
            <label>Member City *</label>
            <input
              type="text"
              name="member_city"
              value={formData.member_address.member_city}
              onChange={handleChange}
              className={errors.member_city ? "error-border" : ""}
            />
            {errors.member_city && (
              <span className="error-text">{errors.member_city}</span>
            )}
          </div>

          <div className="root_btn_group">
            <button type="submit" value="draft" className="submit-btn">
              Save on Draft
            </button>

            <button type="submit" value="proceed" className="submit-btn">
              Proceed
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default CompanyFromStep;
